'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { segmentBunja } from '@flipster/utils/segment/bunja';

export const useGetUrlWithAnonymousId = () => {
  const { anonymousIdAtom } = useBunja(segmentBunja);
  const anonymousId = useAtomValue(anonymousIdAtom);

  return useCallback(
    (key: OnelinkPathKey) => {
      const url = OnelinkPaths[key];
      if (!url) return '';

      try {
        const urlObj = new URL(url);
        urlObj.searchParams.set('anon_id', anonymousId);
        return urlObj.toString();
      } catch {
        // URL 파싱 실패시 원본 반환
        return url;
      }
    },
    [anonymousId],
  );
};

export const useGetUrlWithAnonymousIdWithoutKey = () => {
  const { anonymousIdAtom } = useBunja(segmentBunja);
  const anonymousId = useAtomValue(anonymousIdAtom);

  return useCallback(
    (url: string) => {
      try {
        const urlObj = new URL(url);
        urlObj.searchParams.set('anon_id', anonymousId);
        return urlObj.toString();
      } catch {
        // URL 파싱 실패시 원본 반환
        return url;
      }
    },
    [anonymousId],
  );
};

// 직접 참조하지 말고 useGetUrlWithAnonymousId 사용
const OnelinkPaths = {
  Download: 'https://flipster.onelink.me/4RuL/webhomepage',
  // TODO: [sh] PC에서 playstore 링크 클릭 시 appstore로 이동되어 임시 추가
  PlaystoreDownload: 'https://flipster.onelink.me/8tso/playstorehomepage',
  PlaystoreDownloadForEmailLanding: 'https://flipster.onelink.me/8tso/a9llrj3h',
  AppStoreDownloadForEmailLanding: 'https://flipster.onelink.me/mwmX/ugp5i5mh',
  DownloadAppForTrade: 'https://flipster.onelink.me/4RuL/rawhypyj',
  // FAQ에서 사용되는 링크들
  WebFaq: 'https://flipster.onelink.me/4RuL/webfaq',
  AndroidFaq: 'https://flipster.onelink.me/8tso/bbbfa2rn',
  // Social Referral에서 사용되는 링크
  SocialReferral: 'https://flipster.onelink.me/v7lt/04bk2i4h',
} as const;

export type OnelinkPathUrl = (typeof OnelinkPaths)[keyof typeof OnelinkPaths];
export type OnelinkPathKey = keyof typeof OnelinkPaths;
